import ImagesSlider from 'assets/core/js/module/imagesSlider'
import SliderManager from 'assets/core/js/module/sliderManager'

export default function (): void {
  ImagesSlider(document.querySelector<HTMLElement>('.booking__product .swiper') as HTMLElement)

  const defaultConfig = {
    // set loop to false as a temporary fix (setting it to true will increase CLS)
    // https://github.com/nolimits4web/swiper/issues/4076
    loop: false,
    grabCursor: true,
    speed: 1000,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    pagination: {
      clickable: true,
      el: '#booking-product-top-reviews-slider-pagination',
    },
  }

  SliderManager.initSlider('#booking-product-top-reviews-slider', defaultConfig)
}
